import { render, staticRenderFns } from "./PresentationCard.vue?vue&type=template&id=11644e95"
import script from "./PresentationCard.vue?vue&type=script&lang=ts"
export * from "./PresentationCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports